module.exports = __webpack_public_path__ + "static/media/book2.5b446608.png";